/** Inclusive ISO day (YYYY-MM-DD) in UTC. */
export function isoDay(date: Date): string {
  return date.toISOString().slice(0, 10)
}

/** Trailing 30-day window ending today — the dashboard's default range. */
export function defaultRange(today: Date = new Date()): { from: string; to: string } {
  return rangeFromDays(30, today)
}

/** Trailing window of `days` calendar days (inclusive) ending today, as UTC
 * ISO days. Drives the Statistikk page's preset range selector. */
export function rangeFromDays(
  days: number,
  today: Date = new Date(),
): { from: string; to: string } {
  const fromDate = new Date(today)
  fromDate.setUTCDate(fromDate.getUTCDate() - (days - 1))
  return { from: isoDay(fromDate), to: isoDay(today) }
}

/** Norwegian day-first date (`DD.MM.YYYY`) from a UTC ISO day — never the
 * American `MM/DD`. */
export function formatNorwegianDay(isoDayValue: string): string {
  const [year = '', month = '', day = ''] = isoDayValue.split('-')
  return `${day}.${month}.${year}`
}

/** True when the UTC ISO day is a Saturday or Sunday. */
export function isWeekend(isoDayValue: string): boolean {
  const dayOfWeek = new Date(`${isoDayValue}T00:00:00Z`).getUTCDay()
  return dayOfWeek === 0 || dayOfWeek === 6
}

const YEAR_MS = 365 * 24 * 60 * 60 * 1000

/** Compact axis labels for a series of ISO days: "DD.MM", widening to
 * "DD.MM.YY" only when the span reaches a year (where DD.MM would be
 * ambiguous). */
export function formatDayLabels(days: string[]): string[] {
  if (days.length === 0) return []
  const times = days.map((day) => Date.parse(day))
  const withYear = Math.max(...times) - Math.min(...times) >= YEAR_MS
  return days.map((day) => {
    const [year = '', month = '', date = ''] = day.split('-')
    return withYear ? `${date}.${month}.${year.slice(2)}` : `${date}.${month}`
  })
}
